import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

/** Campaigns area shell: the list, the wizard and campaign pages render inside. */
@Component({
  selector: 'app-campaigns',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './campaigns.component.html',
  styles: `
    :host {
      display: block;
    }
  `,
})
export class CampaignsComponent {}
